import { connect } from 'react-redux';
import PromoItems from '../../../components/event/after-action/promo-items/index';
import {
    addPromoItems,
    deletePromoItems,
    updateAfterAction,
    approveAfterAction,
    requestInfoAfterAction,
    updateAndSubmitAfterAction,
    setEventUserAction,
    setEventErrorMessage,
    updatePromoItemsTotal,
    addPromoLineItem,
    clearPromoLineItem,
    loadPromoItem,
    handlePromoItemsThunk,
    toggleAARequestModal,
    deletePromoItemThunk,
    setFormFieldValidity
} from '../../../actions';
import {
    getEventActions,
    getEventStatus,
    getJwtToken
} from '../../../reducers';

const mapStateToProps = state => ({
    jwtToken: getJwtToken(state),
    promoItems: state.ui.promoItems,
    eventActions: getEventActions(state),
    status: getEventStatus(state),
    userInfo: state.data.userInfo,
    hasActions: state.events.hasAfterActionActions,
    userIsCreator: state.events.userIsCreator,
    userAction: state.events.userAction,
    approvers: state.events.aaApprovers,
    tasks: state.events.aaTasks,
    aaStatus: state.events.aaStatus,
    eventForm: state.event,
    requestModalActive: state.events.aaRequestModalActive,
    afterActionUserID: state.event.EventReport.userId,
    groupStatus: state.events.groupStatus,
    eventState: state.event
});

const mapDispatchToProps = dispatch => ({
    addPromoItems: data => dispatch(addPromoItems(data)),
    deletePromoItems: data => dispatch(deletePromoItems(data)),
    updateAfterAction: data => dispatch(updateAfterAction(data)),
    approveAfterAction: data => dispatch(approveAfterAction(data)),
    requestInfoAfterAction: data => dispatch(requestInfoAfterAction(data)),
    submitAfterAction: data => dispatch(updateAndSubmitAfterAction(data)),
    setEventUserAction: action => dispatch(setEventUserAction(action)),
    setEventErrorMessage: msg => dispatch(setEventErrorMessage(msg)),
    updatePromoItemsTotal: total => dispatch(updatePromoItemsTotal(total)),
    addPromoLineItem: object => dispatch(addPromoLineItem(object)),
    clearPromoLineItem: object => dispatch(clearPromoLineItem(object)),
    loadPromoItem: object => dispatch(loadPromoItem(object)),
    handlePromoItemsThunk: (eventId, promoItems) =>
        dispatch(handlePromoItemsThunk(eventId, promoItems)),
    toggleRequestModal: () => dispatch(toggleAARequestModal()),
    deletePromoItemThunk: (id, promoItemId) =>
        dispatch(deletePromoItemThunk(id, promoItemId)),
    setFormFieldValidity: (model, bool) =>
        dispatch(setFormFieldValidity(model, bool))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PromoItems);



// WEBPACK FOOTER //
// ./src/containers/event/after-action/promo-items.js